"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceSupportServiceServer = exports.AudienceSupportServiceDispatcher = exports.AudienceSupportServiceClient = void 0;
var irt_1 = require("@playq/irt");
var octopus_common_1 = require("@playq/octopus-common");
var services_shared_1 = require("@playq/services-shared");
var services_beetle_1 = require("@playq/services-beetle");
var irt_2 = require("@playq/irt");
var InSearchAttachments = (function () {
    function InSearchAttachments(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.query = new services_beetle_1.AttachmentSearchQuery(data.query);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InSearchAttachments.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchAttachments.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field query is not optional');
            }
            this._query = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchAttachments.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchAttachments.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InSearchAttachments.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            query: this.query.serialize(),
            iterator: this.iterator.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InSearchAttachments;
}());
var OutSearchAttachmentsHelpers = (function () {
    function OutSearchAttachmentsHelpers() {
    }
    OutSearchAttachmentsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSearchAttachmentsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.AttachmentsResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSearchAttachmentsHelpers;
}());
var InQuerySupportRequestsMeta = (function () {
    function InQuerySupportRequestsMeta(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.keys = data.keys;
        this.valuesPerKey = data.valuesPerKey;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQuerySupportRequestsMeta.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequestsMeta.prototype, "keys", {
        get: function () {
            return this._keys;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field keys is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field keys expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field keys is expected to be an integer, got ' + value);
            }
            this._keys = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequestsMeta.prototype, "valuesPerKey", {
        get: function () {
            return this._valuesPerKey;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field valuesPerKey is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field valuesPerKey expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field valuesPerKey is expected to be an integer, got ' + value);
            }
            this._valuesPerKey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequestsMeta.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQuerySupportRequestsMeta.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            keys: this.keys,
            valuesPerKey: this.valuesPerKey,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQuerySupportRequestsMeta;
}());
var OutQuerySupportRequestsMetaHelpers = (function () {
    function OutQuerySupportRequestsMetaHelpers() {
    }
    OutQuerySupportRequestsMetaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQuerySupportRequestsMetaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.MetaResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQuerySupportRequestsMetaHelpers;
}());
var InQuerySupportRequests = (function () {
    function InQuerySupportRequests(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new services_beetle_1.SupportRequestSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQuerySupportRequests.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequests.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequests.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequests.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQuerySupportRequests.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQuerySupportRequests.prototype.serialize = function () {
        var _this = this;
        return {
            appID: this.appID.serialize(),
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQuerySupportRequests;
}());
var OutQuerySupportRequestsHelpers = (function () {
    function OutQuerySupportRequestsHelpers() {
    }
    OutQuerySupportRequestsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQuerySupportRequestsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.SupportRequestsResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQuerySupportRequestsHelpers;
}());
var InSearchSupportRequestsByAttachments = (function () {
    function InSearchSupportRequestsByAttachments(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.query = new services_beetle_1.AttachmentSearchQuery(data.query);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InSearchSupportRequestsByAttachments.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchSupportRequestsByAttachments.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field query is not optional');
            }
            this._query = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchSupportRequestsByAttachments.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchSupportRequestsByAttachments.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchSupportRequestsByAttachments.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InSearchSupportRequestsByAttachments.prototype.serialize = function () {
        var _this = this;
        return {
            appID: this.appID.serialize(),
            query: this.query.serialize(),
            iterator: this.iterator.serialize(),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InSearchSupportRequestsByAttachments;
}());
var OutSearchSupportRequestsByAttachmentsHelpers = (function () {
    function OutSearchSupportRequestsByAttachmentsHelpers() {
    }
    OutSearchSupportRequestsByAttachmentsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSearchSupportRequestsByAttachmentsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.SupportRequestsAttachmentSearchResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSearchSupportRequestsByAttachmentsHelpers;
}());
var InRetrieveSupportRequest = (function () {
    function InRetrieveSupportRequest(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.SupportRequestId(data.id);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InRetrieveSupportRequest.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveSupportRequest.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveSupportRequest.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InRetrieveSupportRequest;
}());
var OutRetrieveSupportRequestHelpers = (function () {
    function OutRetrieveSupportRequestHelpers() {
    }
    OutRetrieveSupportRequestHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveSupportRequestHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.AppSupportRequest(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveSupportRequestHelpers;
}());
var InUpdateRequestStatus = (function () {
    function InUpdateRequestStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.SupportRequestId(data.id);
        this.status = services_beetle_1.RequestStatusHelpers.deserialize(data.status);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateRequestStatus.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateRequestStatus.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field status is not optional');
            }
            this._status = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateRequestStatus.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateRequestStatus.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            status: services_beetle_1.RequestStatusHelpers.serialize(this.status),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateRequestStatus;
}());
var OutUpdateRequestStatusHelpers = (function () {
    function OutUpdateRequestStatusHelpers() {
    }
    OutUpdateRequestStatusHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateRequestStatusHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.AppSupportRequest(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateRequestStatusHelpers;
}());
var InUpdateRequestStatusBatch = (function () {
    function InUpdateRequestStatusBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new services_beetle_1.SupportRequestId(e); });
        this.status = services_beetle_1.RequestStatusHelpers.deserialize(data.status);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateRequestStatusBatch.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateRequestStatusBatch.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field status is not optional');
            }
            this._status = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateRequestStatusBatch.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateRequestStatusBatch.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); }),
            status: services_beetle_1.RequestStatusHelpers.serialize(this.status),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateRequestStatusBatch;
}());
var OutUpdateRequestStatusBatchHelpers = (function () {
    function OutUpdateRequestStatusBatchHelpers() {
    }
    OutUpdateRequestStatusBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateRequestStatusBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateRequestStatusBatchHelpers;
}());
var InDeleteSupportRequest = (function () {
    function InDeleteSupportRequest(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.SupportRequestId(data.id);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteSupportRequest.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteSupportRequest.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteSupportRequest.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteSupportRequest;
}());
var OutDeleteSupportRequestHelpers = (function () {
    function OutDeleteSupportRequestHelpers() {
    }
    OutDeleteSupportRequestHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteSupportRequestHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteSupportRequestHelpers;
}());
var InDeleteSupportRequestBatch = (function () {
    function InDeleteSupportRequestBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new services_beetle_1.SupportRequestId(e); });
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteSupportRequestBatch.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteSupportRequestBatch.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteSupportRequestBatch.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); }),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteSupportRequestBatch;
}());
var OutDeleteSupportRequestBatchHelpers = (function () {
    function OutDeleteSupportRequestBatchHelpers() {
    }
    OutDeleteSupportRequestBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteSupportRequestBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteSupportRequestBatchHelpers;
}());
var InAddSupportRequestsNote = (function () {
    function InAddSupportRequestsNote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.SupportRequestId(data.id);
        this.note = data.note;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InAddSupportRequestsNote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddSupportRequestsNote.prototype, "note", {
        get: function () {
            return this._note;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field note is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field note expects type string, got ' + value);
            }
            this._note = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddSupportRequestsNote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InAddSupportRequestsNote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            note: this.note,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InAddSupportRequestsNote;
}());
var OutAddSupportRequestsNoteHelpers = (function () {
    function OutAddSupportRequestsNoteHelpers() {
    }
    OutAddSupportRequestsNoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutAddSupportRequestsNoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(content);
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAddSupportRequestsNoteHelpers;
}());
var InUpdateSupportRequestsNote = (function () {
    function InUpdateSupportRequestsNote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.SupportRequestId(data.id);
        this.noteId = data.noteId;
        this.note = data.note;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateSupportRequestsNote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateSupportRequestsNote.prototype, "noteId", {
        get: function () {
            return this._noteId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field noteId is not optional');
            }
            this._noteId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateSupportRequestsNote.prototype, "note", {
        get: function () {
            return this._note;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field note is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field note expects type string, got ' + value);
            }
            this._note = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateSupportRequestsNote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateSupportRequestsNote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            noteId: this.noteId,
            note: this.note,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateSupportRequestsNote;
}());
var OutUpdateSupportRequestsNoteHelpers = (function () {
    function OutUpdateSupportRequestsNoteHelpers() {
    }
    OutUpdateSupportRequestsNoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateSupportRequestsNoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateSupportRequestsNoteHelpers;
}());
var InDeleteSupportRequestsNote = (function () {
    function InDeleteSupportRequestsNote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.SupportRequestId(data.id);
        this.noteId = data.noteId;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteSupportRequestsNote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteSupportRequestsNote.prototype, "noteId", {
        get: function () {
            return this._noteId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field noteId is not optional');
            }
            this._noteId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteSupportRequestsNote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteSupportRequestsNote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            noteId: this.noteId,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteSupportRequestsNote;
}());
var OutDeleteSupportRequestsNoteHelpers = (function () {
    function OutDeleteSupportRequestsNoteHelpers() {
    }
    OutDeleteSupportRequestsNoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteSupportRequestsNoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteSupportRequestsNoteHelpers;
}());
var InQueryIssuesMeta = (function () {
    function InQueryIssuesMeta(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.keys = data.keys;
        this.valuesPerKey = data.valuesPerKey;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryIssuesMeta.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssuesMeta.prototype, "keys", {
        get: function () {
            return this._keys;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field keys is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field keys expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field keys is expected to be an integer, got ' + value);
            }
            this._keys = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssuesMeta.prototype, "valuesPerKey", {
        get: function () {
            return this._valuesPerKey;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field valuesPerKey is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field valuesPerKey expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field valuesPerKey is expected to be an integer, got ' + value);
            }
            this._valuesPerKey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssuesMeta.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryIssuesMeta.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            keys: this.keys,
            valuesPerKey: this.valuesPerKey,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryIssuesMeta;
}());
var OutQueryIssuesMetaHelpers = (function () {
    function OutQueryIssuesMetaHelpers() {
    }
    OutQueryIssuesMetaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryIssuesMetaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.MetaResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryIssuesMetaHelpers;
}());
var InQueryIssues = (function () {
    function InQueryIssues(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new services_beetle_1.IssueSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryIssues.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssues.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssues.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssues.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIssues.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryIssues.prototype.serialize = function () {
        var _this = this;
        return {
            appID: this.appID.serialize(),
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryIssues;
}());
var OutQueryIssuesHelpers = (function () {
    function OutQueryIssuesHelpers() {
    }
    OutQueryIssuesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryIssuesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.IssuesResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryIssuesHelpers;
}());
var InSearchIssuesByAttachments = (function () {
    function InSearchIssuesByAttachments(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.query = new services_beetle_1.AttachmentSearchQuery(data.query);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InSearchIssuesByAttachments.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchIssuesByAttachments.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field query is not optional');
            }
            this._query = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchIssuesByAttachments.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchIssuesByAttachments.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchIssuesByAttachments.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InSearchIssuesByAttachments.prototype.serialize = function () {
        var _this = this;
        return {
            appID: this.appID.serialize(),
            query: this.query.serialize(),
            iterator: this.iterator.serialize(),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InSearchIssuesByAttachments;
}());
var OutSearchIssuesByAttachmentsHelpers = (function () {
    function OutSearchIssuesByAttachmentsHelpers() {
    }
    OutSearchIssuesByAttachmentsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSearchIssuesByAttachmentsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.IssuesAttachmentsSearchResponse(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSearchIssuesByAttachmentsHelpers;
}());
var InRetrieveIssue = (function () {
    function InRetrieveIssue(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.IssueId(data.id);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InRetrieveIssue.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveIssue.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveIssue.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InRetrieveIssue;
}());
var OutRetrieveIssueHelpers = (function () {
    function OutRetrieveIssueHelpers() {
    }
    OutRetrieveIssueHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveIssueHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_beetle_1.AppIssue(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveIssueHelpers;
}());
var InUpdateIssueStatus = (function () {
    function InUpdateIssueStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.IssueId(data.id);
        this.resolved = data.resolved;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateIssueStatus.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueStatus.prototype, "resolved", {
        get: function () {
            return this._resolved;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field resolved is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field resolved expects boolean type, got ' + value);
            }
            this._resolved = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueStatus.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateIssueStatus.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            resolved: this.resolved,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateIssueStatus;
}());
var OutUpdateIssueStatusHelpers = (function () {
    function OutUpdateIssueStatusHelpers() {
    }
    OutUpdateIssueStatusHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateIssueStatusHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateIssueStatusHelpers;
}());
var InUpdateIssueStatusBatch = (function () {
    function InUpdateIssueStatusBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new services_beetle_1.IssueId(e); });
        this.resolved = data.resolved;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateIssueStatusBatch.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueStatusBatch.prototype, "resolved", {
        get: function () {
            return this._resolved;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field resolved is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field resolved expects boolean type, got ' + value);
            }
            this._resolved = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueStatusBatch.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateIssueStatusBatch.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); }),
            resolved: this.resolved,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateIssueStatusBatch;
}());
var OutUpdateIssueStatusBatchHelpers = (function () {
    function OutUpdateIssueStatusBatchHelpers() {
    }
    OutUpdateIssueStatusBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateIssueStatusBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateIssueStatusBatchHelpers;
}());
var InDeleteIssue = (function () {
    function InDeleteIssue(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.IssueId(data.id);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteIssue.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteIssue.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteIssue.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteIssue;
}());
var OutDeleteIssueHelpers = (function () {
    function OutDeleteIssueHelpers() {
    }
    OutDeleteIssueHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteIssueHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteIssueHelpers;
}());
var InDeleteIssueBatch = (function () {
    function InDeleteIssueBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new services_beetle_1.IssueId(e); });
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteIssueBatch.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteIssueBatch.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteIssueBatch.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); }),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteIssueBatch;
}());
var OutDeleteIssueBatchHelpers = (function () {
    function OutDeleteIssueBatchHelpers() {
    }
    OutDeleteIssueBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteIssueBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteIssueBatchHelpers;
}());
var InAddIssueNote = (function () {
    function InAddIssueNote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.IssueId(data.id);
        this.note = data.note;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InAddIssueNote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddIssueNote.prototype, "note", {
        get: function () {
            return this._note;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field note is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field note expects type string, got ' + value);
            }
            this._note = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAddIssueNote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InAddIssueNote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            note: this.note,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InAddIssueNote;
}());
var OutAddIssueNoteHelpers = (function () {
    function OutAddIssueNoteHelpers() {
    }
    OutAddIssueNoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutAddIssueNoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(content);
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAddIssueNoteHelpers;
}());
var InUpdateIssueNote = (function () {
    function InUpdateIssueNote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.IssueId(data.id);
        this.noteId = data.noteId;
        this.env = octopus_common_1.Environment[data.env];
        this.note = data.note;
    }
    Object.defineProperty(InUpdateIssueNote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueNote.prototype, "noteId", {
        get: function () {
            return this._noteId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field noteId is not optional');
            }
            this._noteId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueNote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateIssueNote.prototype, "note", {
        get: function () {
            return this._note;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field note is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field note expects type string, got ' + value);
            }
            this._note = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateIssueNote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            noteId: this.noteId,
            env: octopus_common_1.Environment[this.env],
            note: this.note
        };
    };
    return InUpdateIssueNote;
}());
var OutUpdateIssueNoteHelpers = (function () {
    function OutUpdateIssueNoteHelpers() {
    }
    OutUpdateIssueNoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateIssueNoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateIssueNoteHelpers;
}());
var InDeleteIssueNote = (function () {
    function InDeleteIssueNote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new services_beetle_1.IssueId(data.id);
        this.noteId = data.noteId;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteIssueNote.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteIssueNote.prototype, "noteId", {
        get: function () {
            return this._noteId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field noteId is not optional');
            }
            this._noteId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteIssueNote.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteIssueNote.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            noteId: this.noteId,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteIssueNote;
}());
var OutDeleteIssueNoteHelpers = (function () {
    function OutDeleteIssueNoteHelpers() {
    }
    OutDeleteIssueNoteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteIssueNoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteIssueNoteHelpers;
}());
var InDropAttachmentsIndexFor = (function () {
    function InDropAttachmentsIndexFor(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.from_AsString = data.from;
        this.toAsString = data.to;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDropAttachmentsIndexFor.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDropAttachmentsIndexFor.prototype, "from_", {
        get: function () {
            return this._from;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field from_ is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field from_ expects type Date, got ' + value);
            }
            this._from = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDropAttachmentsIndexFor.prototype, "from_AsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._from);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('from_AsString expects type string, got ' + value);
            }
            this._from = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDropAttachmentsIndexFor.prototype, "to", {
        get: function () {
            return this._to;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field to is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field to expects type Date, got ' + value);
            }
            this._to = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDropAttachmentsIndexFor.prototype, "toAsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._to);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('toAsString expects type string, got ' + value);
            }
            this._to = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDropAttachmentsIndexFor.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDropAttachmentsIndexFor.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            from: this.from_AsString,
            to: this.toAsString,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDropAttachmentsIndexFor;
}());
var OutDropAttachmentsIndexForHelpers = (function () {
    function OutDropAttachmentsIndexForHelpers() {
    }
    OutDropAttachmentsIndexForHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDropAttachmentsIndexForHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDropAttachmentsIndexForHelpers;
}());
var InDropAttachmentsIndex = (function () {
    function InDropAttachmentsIndex(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDropAttachmentsIndex.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDropAttachmentsIndex.prototype.serialize = function () {
        return {
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDropAttachmentsIndex;
}());
var OutDropAttachmentsIndexHelpers = (function () {
    function OutDropAttachmentsIndexHelpers() {
    }
    OutDropAttachmentsIndexHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDropAttachmentsIndexHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDropAttachmentsIndexHelpers;
}());
var AudienceSupportServiceClient = (function () {
    function AudienceSupportServiceClient(transport) {
        this._transport = transport;
    }
    AudienceSupportServiceClient.prototype.getPackageName = function () { return AudienceSupportServiceClient.PackageName; };
    AudienceSupportServiceClient.prototype.getClassName = function () { return AudienceSupportServiceClient.ClassName; };
    AudienceSupportServiceClient.prototype.getFullClassName = function () { return AudienceSupportServiceClient.FullClassName; };
    AudienceSupportServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.searchAttachments = function (appID, query, iterator, env) {
        var _this = this;
        var __data = new InSearchAttachments();
        __data.appID = appID;
        __data.query = query;
        __data.iterator = iterator;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'searchAttachments', __data)
                .then(function (data) {
                try {
                    resolve(OutSearchAttachmentsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.querySupportRequestsMeta = function (appID, keys, valuesPerKey, env) {
        var _this = this;
        var __data = new InQuerySupportRequestsMeta();
        __data.appID = appID;
        __data.keys = keys;
        __data.valuesPerKey = valuesPerKey;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'querySupportRequestsMeta', __data)
                .then(function (data) {
                try {
                    resolve(OutQuerySupportRequestsMetaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.querySupportRequests = function (appID, iterator, sortBy, filterBy, env) {
        var _this = this;
        var __data = new InQuerySupportRequests();
        __data.appID = appID;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'querySupportRequests', __data)
                .then(function (data) {
                try {
                    resolve(OutQuerySupportRequestsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.searchSupportRequestsByAttachments = function (appID, query, iterator, filterBy, env) {
        var _this = this;
        var __data = new InSearchSupportRequestsByAttachments();
        __data.appID = appID;
        __data.query = query;
        __data.iterator = iterator;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'searchSupportRequestsByAttachments', __data)
                .then(function (data) {
                try {
                    resolve(OutSearchSupportRequestsByAttachmentsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.retrieveSupportRequest = function (id, env) {
        var _this = this;
        var __data = new InRetrieveSupportRequest();
        __data.id = id;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'retrieveSupportRequest', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveSupportRequestHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.updateRequestStatus = function (id, status, env) {
        var _this = this;
        var __data = new InUpdateRequestStatus();
        __data.id = id;
        __data.status = status;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'updateRequestStatus', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateRequestStatusHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.updateRequestStatusBatch = function (ids, status, env) {
        var _this = this;
        var __data = new InUpdateRequestStatusBatch();
        __data.ids = ids;
        __data.status = status;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'updateRequestStatusBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateRequestStatusBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.deleteSupportRequest = function (id, env) {
        var _this = this;
        var __data = new InDeleteSupportRequest();
        __data.id = id;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'deleteSupportRequest', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteSupportRequestHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.deleteSupportRequestBatch = function (ids, env) {
        var _this = this;
        var __data = new InDeleteSupportRequestBatch();
        __data.ids = ids;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'deleteSupportRequestBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteSupportRequestBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.addSupportRequestsNote = function (id, note, env) {
        var _this = this;
        var __data = new InAddSupportRequestsNote();
        __data.id = id;
        __data.note = note;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'addSupportRequestsNote', __data)
                .then(function (data) {
                try {
                    resolve(OutAddSupportRequestsNoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.updateSupportRequestsNote = function (id, noteId, note, env) {
        var _this = this;
        var __data = new InUpdateSupportRequestsNote();
        __data.id = id;
        __data.noteId = noteId;
        __data.note = note;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'updateSupportRequestsNote', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateSupportRequestsNoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.deleteSupportRequestsNote = function (id, noteId, env) {
        var _this = this;
        var __data = new InDeleteSupportRequestsNote();
        __data.id = id;
        __data.noteId = noteId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'deleteSupportRequestsNote', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteSupportRequestsNoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.queryIssuesMeta = function (appID, keys, valuesPerKey, env) {
        var _this = this;
        var __data = new InQueryIssuesMeta();
        __data.appID = appID;
        __data.keys = keys;
        __data.valuesPerKey = valuesPerKey;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'queryIssuesMeta', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryIssuesMetaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.queryIssues = function (appID, iterator, sortBy, filterBy, env) {
        var _this = this;
        var __data = new InQueryIssues();
        __data.appID = appID;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'queryIssues', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryIssuesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.searchIssuesByAttachments = function (appID, query, iterator, filterBy, env) {
        var _this = this;
        var __data = new InSearchIssuesByAttachments();
        __data.appID = appID;
        __data.query = query;
        __data.iterator = iterator;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'searchIssuesByAttachments', __data)
                .then(function (data) {
                try {
                    resolve(OutSearchIssuesByAttachmentsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.retrieveIssue = function (id, env) {
        var _this = this;
        var __data = new InRetrieveIssue();
        __data.id = id;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'retrieveIssue', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveIssueHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.updateIssueStatus = function (id, resolved, env) {
        var _this = this;
        var __data = new InUpdateIssueStatus();
        __data.id = id;
        __data.resolved = resolved;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'updateIssueStatus', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateIssueStatusHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.updateIssueStatusBatch = function (ids, resolved, env) {
        var _this = this;
        var __data = new InUpdateIssueStatusBatch();
        __data.ids = ids;
        __data.resolved = resolved;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'updateIssueStatusBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateIssueStatusBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.deleteIssue = function (id, env) {
        var _this = this;
        var __data = new InDeleteIssue();
        __data.id = id;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'deleteIssue', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteIssueHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.deleteIssueBatch = function (ids, env) {
        var _this = this;
        var __data = new InDeleteIssueBatch();
        __data.ids = ids;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'deleteIssueBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteIssueBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.addIssueNote = function (id, note, env) {
        var _this = this;
        var __data = new InAddIssueNote();
        __data.id = id;
        __data.note = note;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'addIssueNote', __data)
                .then(function (data) {
                try {
                    resolve(OutAddIssueNoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.updateIssueNote = function (id, noteId, env, note) {
        var _this = this;
        var __data = new InUpdateIssueNote();
        __data.id = id;
        __data.noteId = noteId;
        __data.env = env;
        __data.note = note;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'updateIssueNote', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateIssueNoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.deleteIssueNote = function (id, noteId, env) {
        var _this = this;
        var __data = new InDeleteIssueNote();
        __data.id = id;
        __data.noteId = noteId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'deleteIssueNote', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteIssueNoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.dropAttachmentsIndexFor = function (appID, from_, to, env) {
        var _this = this;
        var __data = new InDropAttachmentsIndexFor();
        __data.appID = appID;
        __data.from_ = from_;
        __data.to = to;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'dropAttachmentsIndexFor', __data)
                .then(function (data) {
                try {
                    resolve(OutDropAttachmentsIndexForHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.prototype.dropAttachmentsIndex = function (env) {
        var _this = this;
        var __data = new InDropAttachmentsIndex();
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceSupportServiceClient.ClassName, 'dropAttachmentsIndex', __data)
                .then(function (data) {
                try {
                    resolve(OutDropAttachmentsIndexHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceSupportServiceClient.PackageName = 'net.playq.octopus2.audience';
    AudienceSupportServiceClient.ClassName = 'AudienceSupportService';
    AudienceSupportServiceClient.FullClassName = 'net.playq.octopus2.audience.AudienceSupportService';
    return AudienceSupportServiceClient;
}());
exports.AudienceSupportServiceClient = AudienceSupportServiceClient;
var AudienceSupportServiceDispatcher = (function () {
    function AudienceSupportServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    AudienceSupportServiceDispatcher.prototype.getSupportedService = function () {
        return 'AudienceSupportService';
    };
    AudienceSupportServiceDispatcher.prototype.getSupportedMethods = function () {
        return AudienceSupportServiceDispatcher.methods;
    };
    AudienceSupportServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "searchAttachments": {
                var obj_1 = new InSearchAttachments(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.searchAttachments(context, obj_1.appID, obj_1.query, obj_1.iterator, obj_1.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSearchAttachmentsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "querySupportRequestsMeta": {
                var obj_2 = new InQuerySupportRequestsMeta(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.querySupportRequestsMeta(context, obj_2.appID, obj_2.keys, obj_2.valuesPerKey, obj_2.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQuerySupportRequestsMetaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "querySupportRequests": {
                var obj_3 = new InQuerySupportRequests(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.querySupportRequests(context, obj_3.appID, obj_3.iterator, obj_3.sortBy, obj_3.filterBy, obj_3.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQuerySupportRequestsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "searchSupportRequestsByAttachments": {
                var obj_4 = new InSearchSupportRequestsByAttachments(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.searchSupportRequestsByAttachments(context, obj_4.appID, obj_4.query, obj_4.iterator, obj_4.filterBy, obj_4.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSearchSupportRequestsByAttachmentsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveSupportRequest": {
                var obj_5 = new InRetrieveSupportRequest(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveSupportRequest(context, obj_5.id, obj_5.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveSupportRequestHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateRequestStatus": {
                var obj_6 = new InUpdateRequestStatus(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateRequestStatus(context, obj_6.id, obj_6.status, obj_6.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateRequestStatusHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateRequestStatusBatch": {
                var obj_7 = new InUpdateRequestStatusBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateRequestStatusBatch(context, obj_7.ids, obj_7.status, obj_7.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateRequestStatusBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteSupportRequest": {
                var obj_8 = new InDeleteSupportRequest(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteSupportRequest(context, obj_8.id, obj_8.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteSupportRequestHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteSupportRequestBatch": {
                var obj_9 = new InDeleteSupportRequestBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteSupportRequestBatch(context, obj_9.ids, obj_9.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteSupportRequestBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "addSupportRequestsNote": {
                var obj_10 = new InAddSupportRequestsNote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.addSupportRequestsNote(context, obj_10.id, obj_10.note, obj_10.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAddSupportRequestsNoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateSupportRequestsNote": {
                var obj_11 = new InUpdateSupportRequestsNote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateSupportRequestsNote(context, obj_11.id, obj_11.noteId, obj_11.note, obj_11.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateSupportRequestsNoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteSupportRequestsNote": {
                var obj_12 = new InDeleteSupportRequestsNote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteSupportRequestsNote(context, obj_12.id, obj_12.noteId, obj_12.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteSupportRequestsNoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryIssuesMeta": {
                var obj_13 = new InQueryIssuesMeta(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryIssuesMeta(context, obj_13.appID, obj_13.keys, obj_13.valuesPerKey, obj_13.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryIssuesMetaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryIssues": {
                var obj_14 = new InQueryIssues(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryIssues(context, obj_14.appID, obj_14.iterator, obj_14.sortBy, obj_14.filterBy, obj_14.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryIssuesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "searchIssuesByAttachments": {
                var obj_15 = new InSearchIssuesByAttachments(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.searchIssuesByAttachments(context, obj_15.appID, obj_15.query, obj_15.iterator, obj_15.filterBy, obj_15.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSearchIssuesByAttachmentsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveIssue": {
                var obj_16 = new InRetrieveIssue(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveIssue(context, obj_16.id, obj_16.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveIssueHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateIssueStatus": {
                var obj_17 = new InUpdateIssueStatus(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateIssueStatus(context, obj_17.id, obj_17.resolved, obj_17.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateIssueStatusHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateIssueStatusBatch": {
                var obj_18 = new InUpdateIssueStatusBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateIssueStatusBatch(context, obj_18.ids, obj_18.resolved, obj_18.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateIssueStatusBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteIssue": {
                var obj_19 = new InDeleteIssue(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteIssue(context, obj_19.id, obj_19.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteIssueHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteIssueBatch": {
                var obj_20 = new InDeleteIssueBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteIssueBatch(context, obj_20.ids, obj_20.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteIssueBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "addIssueNote": {
                var obj_21 = new InAddIssueNote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.addIssueNote(context, obj_21.id, obj_21.note, obj_21.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAddIssueNoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateIssueNote": {
                var obj_22 = new InUpdateIssueNote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateIssueNote(context, obj_22.id, obj_22.noteId, obj_22.env, obj_22.note)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateIssueNoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteIssueNote": {
                var obj_23 = new InDeleteIssueNote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteIssueNote(context, obj_23.id, obj_23.noteId, obj_23.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteIssueNoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "dropAttachmentsIndexFor": {
                var obj_24 = new InDropAttachmentsIndexFor(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.dropAttachmentsIndexFor(context, obj_24.appID, obj_24.from_, obj_24.to, obj_24.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDropAttachmentsIndexForHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "dropAttachmentsIndex": {
                var obj_25 = new InDropAttachmentsIndex(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.dropAttachmentsIndex(context, obj_25.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDropAttachmentsIndexHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by AudienceSupportServiceDispatcher."));
        }
    };
    AudienceSupportServiceDispatcher.methods = [
        "searchAttachments",
        "querySupportRequestsMeta",
        "querySupportRequests",
        "searchSupportRequestsByAttachments",
        "retrieveSupportRequest",
        "updateRequestStatus",
        "updateRequestStatusBatch",
        "deleteSupportRequest",
        "deleteSupportRequestBatch",
        "addSupportRequestsNote",
        "updateSupportRequestsNote",
        "deleteSupportRequestsNote",
        "queryIssuesMeta",
        "queryIssues",
        "searchIssuesByAttachments",
        "retrieveIssue",
        "updateIssueStatus",
        "updateIssueStatusBatch",
        "deleteIssue",
        "deleteIssueBatch",
        "addIssueNote",
        "updateIssueNote",
        "deleteIssueNote",
        "dropAttachmentsIndexFor",
        "dropAttachmentsIndex"
    ];
    return AudienceSupportServiceDispatcher;
}());
exports.AudienceSupportServiceDispatcher = AudienceSupportServiceDispatcher;
var AudienceSupportServiceServer = (function (_super) {
    __extends(AudienceSupportServiceServer, _super);
    function AudienceSupportServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    AudienceSupportServiceServer.prototype.searchAttachments = function (context, appID, query, iterator, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.querySupportRequestsMeta = function (context, appID, keys, valuesPerKey, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.querySupportRequests = function (context, appID, iterator, sortBy, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.searchSupportRequestsByAttachments = function (context, appID, query, iterator, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.retrieveSupportRequest = function (context, id, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.updateRequestStatus = function (context, id, status, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.updateRequestStatusBatch = function (context, ids, status, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.deleteSupportRequest = function (context, id, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.deleteSupportRequestBatch = function (context, ids, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.addSupportRequestsNote = function (context, id, note, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.updateSupportRequestsNote = function (context, id, noteId, note, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.deleteSupportRequestsNote = function (context, id, noteId, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.queryIssuesMeta = function (context, appID, keys, valuesPerKey, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.queryIssues = function (context, appID, iterator, sortBy, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.searchIssuesByAttachments = function (context, appID, query, iterator, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.retrieveIssue = function (context, id, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.updateIssueStatus = function (context, id, resolved, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.updateIssueStatusBatch = function (context, ids, resolved, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.deleteIssue = function (context, id, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.deleteIssueBatch = function (context, ids, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.addIssueNote = function (context, id, note, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.updateIssueNote = function (context, id, noteId, env, note) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.deleteIssueNote = function (context, id, noteId, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.dropAttachmentsIndexFor = function (context, appID, from_, to, env) {
        throw new Error('Not implemented.');
    };
    AudienceSupportServiceServer.prototype.dropAttachmentsIndex = function (context, env) {
        throw new Error('Not implemented.');
    };
    return AudienceSupportServiceServer;
}(AudienceSupportServiceDispatcher));
exports.AudienceSupportServiceServer = AudienceSupportServiceServer;
//# sourceMappingURL=AudienceSupportService.js.map